import Highchart from "../Highchart";
import React, { useCallback, useState } from "react";
import { FormControl, FormLabel, Radio, RadioGroup } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import moment from "moment/moment";

export default function Diagrams({
  sla,
  dateFromValue = null,
  dateToValue = null,
}) {
  const [byDays, setByDays] = useState(true);

  const getByDaysData = useCallback((items) => {
    return items.map((el) => {
      return [
        moment(el.date).format("DD.MM.YYYY"),
        parseInt(el.duration) / (60 * 60),
      ];
    });
  }, []);

  const getByUsersData = useCallback((items) => {
    return items.map((el) => {
      return [el.assignee, parseInt(el.duration) / (60 * 60)];
    });
  }, []);

  const getClickParamsByEmail = useCallback((email) => {
    let arr = sla.by_days[email];

    return arr?.map((el) => {
      return { assignee_id: el.assignee_id, date: el.date };
    });
  }, []);

  const getClickParamsByDate = useCallback((date) => {
    let arr = sla.by_users[date];
    return arr?.map((el) => {
      return { assignee_id: el.assignee_id, date: el.date };
    });
  }, []);

  return (
    <>
      <FormControl>
        <FormLabel id="demo-row-radio-buttons-group-label">
          Type of diagram:
        </FormLabel>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          onChange={(event) => {
            setByDays(event.target.value === "days");
          }}
          defaultValue="days"
        >
          <FormControlLabel value="days" control={<Radio />} label="By Days" />
          <FormControlLabel
            value="users"
            control={<Radio />}
            label="By Users"
          />
        </RadioGroup>
      </FormControl>
      {byDays &&
        Object.keys(sla.by_days).map((email, index) => (
          <div key={email}>
            <Highchart
              title={email}
              items={getByDaysData(sla.by_days[email])}
              onClickParams={getClickParamsByEmail(email)}
              onTitleClick={() => {
                let arr = getClickParamsByEmail(email);
                if (arr.length > 0) {
                  let item = arr[0];
                  const url = `/user?id=${item?.assignee_id}&dateFrom=${dateFromValue}&dateTo=${dateToValue}`;
                  window.open(url, "_blank");
                }
              }}
              id={`user-${index}`}
            />
          </div>
        ))}
      {!byDays &&
        Object.keys(sla.by_users).map((date, index) => (
          <div key={date}>
            <Highchart
              title={date}
              items={getByUsersData(sla.by_users[date])}
              onClickParams={getClickParamsByDate(date)}
              id={`date-${index}`}
            />
          </div>
        ))}
    </>
  );
}
